import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectUrl = createSelector(
  (state: RootState) => state.layout.url,
  (url: string) => url
)

export default selectUrl
